import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { goBackAction, pushBaseUrlAction } from 'actions/route/routeAction'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const useHandleBack = () => {
  const dispatch = useDispatch()
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  return useCallback(() => {
    if (authorized) {
      return dispatch(goBackAction())
    }

    dispatch(pushBaseUrlAction())
  }, [dispatch, authorized])
}
